// @ts-nocheck
import ClientViewConfig from "../ClientViewConfig.json";
import Biscuit from "./Biscuit";

// returns the initial view to be displayed after login depending on user role and client
const getInitialView: () => any = (): any => {
  const clientId: string = Biscuit.get("user.client_id");
  const role: string = Biscuit.get("user.role");
  if (ClientViewConfig[clientId] !== undefined) {
    let clientConfig: any = ClientViewConfig[clientId];

    if (clientConfig.initial_view !== undefined) return clientConfig.initial_view[role];
  }
  return ClientViewConfig.default.initial_view[role];
};

// returns all visible / accessible views of requested menu
const getMaintabViews = (mainTab: any): any[] => {
  const clientId: string = Biscuit.get("user.client_id");
  const role: string = Biscuit.get("user.role");
  const config: any =
    ClientViewConfig[clientId] !== undefined && ClientViewConfig[clientId][role] !== undefined
      ? ClientViewConfig[clientId]
      : ClientViewConfig.default;

  let resultList: any[] = [];

  if (mainTab === undefined || mainTab === null) return resultList;

  for (let i in config[role][mainTab]) {
    if (config[role][mainTab][i] === true) {
      resultList.push(i);
    }
  }
  return resultList;
};

// checks if requested view is visible / accessible
const isViewVisible = (name: string, mainTab: any = null): any => {
  const clientId: string = Biscuit.get("user.client_id");
  const role: string = Biscuit.get("user.role");
  const config: any =
    ClientViewConfig[clientId] !== undefined && ClientViewConfig[clientId][role] !== undefined
      ? ClientViewConfig[clientId]
      : ClientViewConfig.default;
  //console.log(config,'config');
  if (mainTab === null) {
    if (config[role][name] !== undefined) return config[role][name];
    else return false;
  } else if (mainTab === undefined) {
    return false;
  } else if (config[role][mainTab] !== undefined && config[role][mainTab][name] !== undefined) {
    return config[role][mainTab][name];
  }
  return false;
};

// checks if requested menu has any submenus and is therefor visible / accessible
const isMaintabVisible: (tabName: string) => boolean = (tabName: string): boolean => {
  const clientId: string = Biscuit.get("user.client_id");
  const role: string = Biscuit.get("user.role");

  if (ClientViewConfig[clientId] !== undefined) {
    // check if client has an own entry

    let clientConfig: any = ClientViewConfig[clientId];

    if (clientConfig[role] !== undefined && clientConfig[role][tabName] !== undefined) {
      for (let i in clientConfig[role][tabName]) {
        if (clientConfig[role][tabName][i] === true) return true; // main tab is visible if any submenu is visible
      }
      return false; // main tab not visible if no submenu is visible
    }
  }
  if (ClientViewConfig.default[role][tabName] === undefined) return false; // return false if requested main tab does not exist
  for (let i in ClientViewConfig.default[role][tabName]) {
    if (ClientViewConfig.default[role][tabName][i] === true) return true; // main tab is visible if any submenu is visible
  }
  return false; // main tab not visible if no submenu is visible
};

export { getInitialView, getMaintabViews, isViewVisible, isMaintabVisible };
